import { useState } from "react";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "redux/actions/auth";

function Basic() {
    const dispatch = useDispatch();
    const { forgetPassLoading } = useSelector(state => state.auth);
    const [form, setForm] = useState({ email: "" });
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        await dispatch(actions.forgetPassword(form));
        setSubmitted(true);
    };

    return (
        <BasicLayout image={bgImage}>
            <Card>
                <MDBox
                    variant="gradient"
                    bgColor="primary"
                    borderRadius="lg"
                    coloredShadow="success"
                    mx={2}
                    mt={-3}
                    py={2}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        Forgot Password
                    </MDTypography>
                </MDBox>
                <MDBox pt={4} pb={3} px={3}>
                    {submitted ? (
                        <MDBox textAlign="center">
                            <MDTypography variant="h6" color="success" mb={2}>
                                Check your email!
                            </MDTypography>
                            <MDTypography variant="body2" color="text" mb={3}>
                                A verification code has been sent to <strong>{form.email}</strong>. Enter it on the Reset Password page.
                            </MDTypography>
                            <MDTypography component={Link} to="/auth/reset-password" variant="button" color="primary" fontWeight="medium">
                                Enter Verification Code →
                            </MDTypography>
                        </MDBox>
                    ) : (
                        <MDBox component="form" role="form">
                            <MDBox mb={4}>
                                <MDInput onChange={handleChange} name="email" type="email" label="Email" variant="standard" fullWidth />
                            </MDBox>
                            <MDBox mt={6} mb={1}>
                                <MDButton onClick={handleSubmit} disabled={forgetPassLoading} variant="gradient" color="primary" fullWidth>
                                    {forgetPassLoading ? "Sending…" : "Send Reset Link"}
                                </MDButton>
                            </MDBox>
                            <MDBox mt={2} textAlign="center">
                                <MDTypography component={Link} to="/auth/login" variant="button" color="primary" fontWeight="medium">
                                    Back to Sign In
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                    )}
                </MDBox>
            </Card>
        </BasicLayout>
    );
}

export default Basic;
